<template>
  <div>
    <el-dialog title="设置支付密码" :visible.sync="isSetPayPassPayPass" width="650px" :before-close="close" :close-on-click-modal="false">
      <div class="link-top"></div>
      <el-form :inline="true" label-width="100px" class="center">
        <div v-if="passwordHidden">
          <el-row style="width: 400px;">
            <el-form-item label="支付密码：" required>
              <el-input v-model='setPass' placeholder='输入6位数字' :type="isDesen ? 'password' : ''" class="input" @input="checkPass(setPass, 'setPass')"></el-input>
              <div @click="select" class="tips">
                <img src="@/assets/password_hide.png" alt="" class="password" v-if="isDesen">
                <img src="@/assets/password_visual.png" alt="" class="password" v-if="!isDesen">
              </div>
            </el-form-item>
            <el-form-item label="再次输入：" required>
              <el-input v-model='confirmPass' placeholder="输入6位数字" :type="isDesenb ? 'password' : ''" class="input" @input="checkPass(confirmPass, 'confirmPass')"></el-input>
              <div @click="selectb" class="tips">
                <img src="@/assets/password_hide.png" alt="" class="password" v-if="isDesenb">
                <img src="@/assets/password_visual.png" alt="" class="password" v-if="!isDesenb">
              </div>
            </el-form-item>
            <el-button class="sure" @click="setPayPass">确定</el-button>
          </el-row>
        </div>
        <div style="text-align: center" v-else>
          <img :src="success" alt="">
          <div class='passSuss' style="color: #333;">重置支付密码成功</div>
          <el-button class="sure-l" @click="sure">确定</el-button>
        </div>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
// import Vue from 'vue'
import CryptoJS from 'crypto-js'
import api from '@/api'
import success from '@/assets/success.png'
export default {
  name: 'set-pass',
  props: {
    userId: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      success: success,
      // 密码
      passwordReg: /^\d{6}$/,
      isSetPayPassPayPass: true,
      passwordHidden: true,
      // 设置交易密码
      setPass: '',
      confirmPass: '',
      encPass: '',

      // 密码脱敏显示
      isDesen: true,
      isDesenb: true,
    }
  },
  methods: {
    // 密码脱敏显示
    select () {
      this.isDesen = !this.isDesen
    },

    // 密码脱敏显示
    selectb () {
      this.isDesenb = !this.isDesenb
    },

    // 关闭忘记密码弹窗
    close () {
      this.$emit('closeMain', false)
    },

    // 数字过滤
    checkReg (e) {
      this.smsCode = e.replace(/[^\d]/g, '')
    },

    // 判断是否是数字
    checkPass (v, k) {
      if (!isNaN(v)) {
        this[k] = v
      } else {
        this[k] = ''
      }
    },

    // 设置支付密码
    setPayPass () {
      if (this.setPass === '') {
        this.$message.error('请输入支付密码')
      } else if (this.confirmPass === '') {
        this.$message.error('请再次输入支付密码')
      } else if (this.setPass !== this.confirmPass) {
        this.$message.error('两次输入的密码不一致')
      } else if (!this.passwordReg.test(this.setPass)) {
        this.$message.error('请设置6位数字')
      } else {
        this.encPass = this.encryptByAes(this.setPass)
        // 设置支付密码
        let param = {
          userId: this.userId,
          newPayPwd: this.encPass,
          aesKey: 'APP7apecSQznwPWD',
          aesIv: '307znw65426apecb'
        }
        api.myAccount.setPayPwd(param).then((res) => {
          this.$message.success('设置成功')
          this.passwordHidden = false
        }).catch((err) => {
          this.$message.error(err)
        })
      }
    },

    // 密码加密
    encryptByAes (psw) {
      let key = CryptoJS.enc.Utf8.parse('APP7apecSQznwPWD') // 秘钥
      let iv = CryptoJS.enc.Utf8.parse('307znw65426apecb') // 偏移量
      let srcs = CryptoJS.enc.Utf8.parse(psw)
      let encrypted = CryptoJS.AES.encrypt(srcs, key, {
        iv: iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7
      })
      return encrypted.ciphertext.toString().toUpperCase()
    },

    // 设置成功关闭弹窗
    sure () {
      this.isSetPayPassPayPass = false
      this.$emit('closeMain', false)
    }
  }
}
</script>

<style lang="scss" scoped>
.password {
  width: 22px;
  height: 10px;
  float: left;
}
.tips {
  position: absolute;
  top: 16px;
  left: 230px;
  width: 25px;
  height: 25px;
}
.link-top {
  width: 100%;
  height: 1px;
  border-top: solid #f8bd47 1px;
  margin-bottom: 30px;
}
.center {
  display: flex;
  align-items: center;
  justify-content: center;
}
.input {
  width: 260px;
  height: 30px;
  line-height: 30px;
}
.code {
  width: 168px;
  height: 30px;
  line-height: 30px;
}
.code-btn {
  cursor:pointer;
  display: inline-block;
  height: 37px;
  width: 88px;
  font-size: 12px;
  text-align: center;
  border: 1px solid #ccc;
  background: #f5f5f5;
  border-radius: 3px;
  line-height: 37px;
  margin-left: 8px;
}
.sure {
  margin: 0 0 0 100px;
  width: 260px;
  background: #f8bd47;
  color: #fff;
}
.sure-l {
  width: 260px;
  background: #f8bd47;
  color: #fff;
  margin-top: 40px;
}
.passSuss {
  font-family: '微软雅黑';
  font-size: 14px;
  margin-top: 20px;
}
</style>
